import { useExportDeviceSettingsQuery } from "generated/graphql";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";
import React, { useContext, useEffect } from "react";
import { ProtectedButton } from "TsRoleGuards";
import { createDownloadableFile } from "utilities/fileUtils";
import { useTranslation } from "utilities/i18n";

export const ExportDevicePolicy: React.FC = () => {
  const { t } = useTranslation();
  const { tenant } = useContext(SelectedTenantContext);

  const {
    data: exportData,
    fetching: exportFetching,
    executor: exportDeviceSettings
  } = useExportDeviceSettingsQuery({
    variables: { tenantId: tenant?.id ?? "" },
    pause: true,
    requestPolicy: "network-only"
  });

  useEffect(() => {
    if (!exportFetching && exportData?.exportDeviceSettings) {
      createDownloadableFile(
        exportData.exportDeviceSettings,
        "device_settings.zip",
        true
      );
    }
  }, [exportFetching, exportData?.exportDeviceSettings]);
  return (
    <ProtectedButton
      className={["btn", exportFetching && "disabled"]
        .filter(c => !!c)
        .join(" ")}
      requirement="READ_TENANT"
      onClick={() => exportDeviceSettings()}
      disabled={exportFetching}
    >
      {exportFetching ? t("EXPORTING") : t("EXPORT_DEVICE_POLICIES")}
    </ProtectedButton>
  );
};
